import { API } from '../Api';

/**
 * Điều kiện mở nhận donate và tích xanh creator do user-service tự kiểm.
 * Chữ của từng mục (label, hint) máy chủ viết sẵn tiếng Việt, web chỉ hiển thị.
 */

export type EligibilityKind = 'donate' | 'creator';

export type RequestStatus = 'none' | 'pending' | 'approved' | 'rejected';

export interface EligibilityItem {
  key: string;
  label: string;
  required: boolean;
  /** true đã đạt, false chưa đạt, null máy chủ chưa kiểm được (Cab xem lúc duyệt). */
  met: boolean | null;
  current?: number | null;
  target?: number | null;
  hint?: string | null;
}

export interface RequestState {
  status: RequestStatus;
  rejectReason?: string | null;
  /** ISO, giờ UTC. */
  repliedAt?: string | null;
  /** ISO, giờ UTC. Chỉ có khi bị từ chối. */
  canResubmitAt?: string | null;
}

export interface EligibilityResult {
  kind: EligibilityKind;
  items: EligibilityItem[];
  requiredMet: boolean;
  allMet: boolean;
  request?: RequestState | null;
}

/** Một số API cũ bọc kết quả trong `data`, endpoint này trả thẳng. Nhận cả hai cho chắc. */
export const unwrapEligibility = (body: any): EligibilityResult => {
  if (body && Array.isArray(body.items)) return body as EligibilityResult;
  return (body?.data ?? body) as EligibilityResult;
};

export const getEligibility = async (kind: EligibilityKind): Promise<EligibilityResult> => {
  const res = await API.get('/v1/user-service/Users/eligibility', { params: { kind } });
  return unwrapEligibility(res.data);
};
